import { useTranslation } from 'react-i18next'
import { AccountSidebarTab } from '../account/AccountSidebarTab'
import { TaxationSidebarTab } from './TaxationPresenter'

interface SidebarProps {
  onTabChange: (tab: TaxationSidebarTab) => void
  tabs: any[]
  activeTab: TaxationSidebarTab
}

export const TaxationSidebar = ({ onTabChange, tabs, activeTab }: SidebarProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="account-sidebar-container">
      <div className="filter-dock-action-buttons-external-container d-flex justify-content-center align-items-center py-3">
        <h4>{t('navigation.taxation')}</h4>
      </div>
      <div className="d-flex flex-column justify-content-center p-2">
        {tabs.map((tab: any) => (
          <AccountSidebarTab
            key={tab.transKey}
            title={t(`${tab.transKey}`)}
            active={activeTab === tab.tab}
            onclick={() => onTabChange(tab.tab)}
            dataTestid={tab.dataTestid}
          />
        ))}
      </div>
    </div>
  )
}
